var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExperience2({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.79149 1.67641L11.0266 4.80539L16.5763 2.27082L15.2157 8.2149L19.3432 12.7043L13.2674 13.249L10.273 18.5637L7.87737 12.9555L1.89953 11.752L6.49154 7.73507L5.79149 1.67641Z",
    fill: "#FFAF14",
    stroke: "#FFAF14",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExperience2);
export default __webpack_public_path__ + "static/media/experience-2.cbf971be8a865b053716589c9462021e.svg";
export { ForwardRef as ReactComponent };